import React from 'react';

import { CategoryExtensionProps } from '../category/category-manager';
import { CompoundPriceComponent } from './price';

export const PriceExtension: React.FC<CategoryExtensionProps> = ({ selectedOption }) => {
  const { base_price, price, net_price } = selectedOption;

  return <CompoundPriceComponent netPrice={net_price} basePrice={base_price} price={price} />;
};
